import React from 'react';

// Styles
import {
	ContentWrapperStyled,
	CenterContainerStyled,
} from './RemoteContainer.styled';

import { TitleStyled } from '../../library/Text.styled';
import { RemoteSessionIconStyled } from '../../library/Icons.styled';

const RemoteContainer = (props) => {
	const { sidePanelIsOpen, currentSelected } = props;

	// Determine if is a remote course
	const showRemoteContainer =
		currentSelected.type === 'single' &&
		!currentSelected.entry.hasOwnProperty('lat') &&
		!currentSelected.entry.hasOwnProperty('long');

	return (
		<ContentWrapperStyled
			className={sidePanelIsOpen && showRemoteContainer ? 'open' : 'closed'}
		>
			<CenterContainerStyled>
				<RemoteSessionIconStyled></RemoteSessionIconStyled>
				<TitleStyled className="color-white extra-large">
					This is a distance<br></br>learning course.
				</TitleStyled>
			</CenterContainerStyled>
		</ContentWrapperStyled>
	);
};

export default RemoteContainer;
